import React from 'react'
import MarkerMapbox from './mapbox'

export default function Marker(props) {
    return (
        <MarkerMapbox {...props}/>
    )
}
